import React from "react";
import { Link } from "react-router-dom";
import SmartPhone from "../Elements/SmartPhone";
import CreditCard from "../Elements/CreditCard";

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-r from-orange-500 via-purple-600 to-purple-800 rounded-b-[120px] overflow-hidden">
      <div className="container mx-auto px-6 py-24 flex flex-col-reverse lg:flex-row items-center">
        
        {/* Text Section */}
        <div className="w-full lg:w-1/2 text-center lg:text-left mt-10 lg:mt-0">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white leading-tight mb-6">
            Powering Africa’s Community Finance — Digitally and Seamlessly.
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-white mb-8">
            Save, borrow, invest, run table banking, digital merry-go-rounds, manage loans, 
            and move money — all in one secure, transparent platform built for Africa’s 
            community-finance economy.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <a 
              href="https://appstore.roshtech.co.ke/apps/edad31f8-921e-4cb0-92dc-d7cbabd0bcde" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 text-lg font-bold rounded-full bg-orange-500 hover:bg-orange-600 text-white transition"
            >
              Download App
            </a>

            <Link 
              to="/how-it-works" 
              className="inline-block px-8 py-4 text-lg font-bold rounded-full bg-purple-700 hover:bg-purple-800 text-white transition"
            >
              How it Works
            </Link>
          </div>
        </div>

        {/* Image Section */}
        <div className="w-full lg:w-1/2 relative flex justify-center lg:justify-end">
          <div className="relative">
            <SmartPhone className="transform rotate-x-[-20deg] rotate-y-[-10deg] lg:w-[300px] w-[200px]" />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-x-[20deg] rotate-y-[10deg] hidden lg:block">
              <CreditCard />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
